import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import "./ContactComponent.css";

const blogSection = {
  /* Blogs Section */

  title: "Blogs",
  subtitle:
    'I believe that "The best way to learn something is to teach others the knowledge that you have gained. Regurgitating that information will solidify it more firmly in your mind." I love to write blog in my free-time.',
  link:
    "https://medium.com/@kuljeetsingh951/what-things-you-can-do-with-javascript-arrays-3bd14965a2df",
  avatar_image_path: "blogs_image.svg",
};

const addressSection = {
  title: "Address",
  subtitle:
    "2310, Gali Number 10, Pocket R, Sanjay Gandhi Memorial Nagar, New Industrial Town, Faridabad, Haryana-121001",
  avatar_image_path: "address.svg",
  location_map_link: "https://goo.gl/maps/YY2p6eJkmNsBZSDk9",
};

const phoneSection = {
  title: "Phone Number",
  subtitle: "+91 9958406550",
};

const ContactData = {
  title: "Contact Me",
  profile_image_path: "badge.png",
  description:
    "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with JavaScript, React, NodeJs, React-Native, MySQL and Opensource Development.",
};

class Contact extends Component {
  render() {
    return (
      <div className="contact-main">
        <Header />
        <div className="basic-contact">
          <Fade bottom duration={1000} distance="40px">
            <div className="contact-heading-div">
              <div className="contact-heading-img-div">
                <img
                  src={require(`../../assests/images/${ContactData["profile_image_path"]}`)}
                  alt=""
                />
              </div>
              <div className="contact-heading-text-div">
                <h1 className="contact-heading-text">{ContactData["title"]}</h1>
                <p className="contact-header-detail-text subTitle">
                  {ContactData["description"]}
                </p>
                <SocialMedia />
                <div className="resume-btn-div">
                  <Button
                    text="Request Resume"
                    newTab={true}
                    href={`mailto:${greeting.email}`}
                  />
                </div>
              </div>
            </div>
          </Fade>
          <Fade bottom duration={1000} distance="40px">
            <div className="blog-heading-div">
              <div className="blog-heading-text-div">
                <h1 className="blog-heading-text">{blogSection["title"]}</h1>
                <p className="blog-header-detail-text subTitle">
                  {blogSection["subtitle"]}
                </p>
                <div className="blogsite-btn-div">
                  <Button
                    text="View My Blog"
                    newTab={true}
                    href={blogSection.link}
                  />
                </div>
              </div>
              <div className="blog-heading-img-div">
                <img
                  src={require(`../../assests/images/${blogSection["avatar_image_path"]}`)}
                  alt=""
                />
              </div>
            </div>
          </Fade>
          <Fade bottom duration={1000} distance="40px">
            <div className="address-heading-div">
              <div className="contact-heading-img-div">
                <img
                  src={require(`../../assests/images/${addressSection["avatar_image_path"]}`)}
                  alt=""
                />
              </div>
              <div className="address-heading-text-div">
                <h1 className="address-heading-text">
                  {addressSection["title"]}
                </h1>
                <p className="contact-header-detail-text subTitle">
                  {addressSection["subtitle"]}
                </p>
                <h1 className="address-heading-text">
                  {phoneSection["title"]}
                </h1>
                <p className="contact-header-detail-text subTitle">
                  {phoneSection["subtitle"]}
                </p>
                <div className="address-btn-div">
                  <Button
                    text="Visit on Google Maps"
                    newTab={true}
                    href={addressSection.location_map_link}
                  />
                </div>
              </div>
            </div>
          </Fade>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Contact;
